import script from "./LoginModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoginModal.vue?vue&type=script&setup=true&lang=ts"

import "./LoginModal.vue?vue&type=style&index=0&id=425ebc52&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-425ebc52"]])

export default __exports__